import * as React from "react";
import {ReactElement, SyntheticEvent} from "react";
import {useStore, useStoreValue} from "react-context-hook";
import Icon from "../Icon";
import {getText} from "../../services/configuration.service";
import {deeplinkAction} from "../../../deeplink/deeplink";
import {sendProductDetailClickedTracking} from "../../../tools/Tracking";
import {atPageBack} from "../../../layout/events";

/**
 * Booking price
 * @constructor
 */
const BookingPrice = (): ReactElement => {
    const selectedDepartureDate = useStoreValue("selectedDepartureDate");
    const bookingEngineData = useStoreValue("bookingEngineData");
    const basePriceAvailability = ((bookingEngineData || {}).product || {}).basePriceAvailability;
    const productType = ((bookingEngineData || {}).product || {}).productStructureType;
    const isPrepackage = productType && productType === "package";
    const priceTypeLabel = basePriceAvailability ?
        (basePriceAvailability.priceTypeBean.byHousing ? getText("product.price.type.housing") : getText("product.price.type.person"))
        : getText("booking.loading.label");
    const [isSubmit, setIsSubmit] = useStore("isSubmit");
    const paxError = useStoreValue("paxError");
    const disabled = paxError !== "" ? "disabled" : "";
    removeLoader();

    const handleSubmit = (evt: any) => {
        setIsSubmit(true);
        evt.preventDefault();
        displayLoader(true);
        sendProductDetailClickedTracking($("#bookingForm"));
        const bookingEngine = document.querySelector("#cptBookingProduct");
        const enableDeeplinkV2 = bookingEngine.getAttribute("data-enable-deeplink-v2");

        if (enableDeeplinkV2 === "true") {
            deeplinkAction($("#bookingForm"));
        } else {
            const bookingForm = document.querySelector("#bookingForm");
            $.ajax("/deeplink/parameters", {
                method: "POST",
                data: $(bookingForm).serializeArray()
            }).done((data: any) => {
                post($(bookingForm).attr("action"), data);
            });
        }
    };
    return (
        <div className="bp-booking-price">
            <div className="booking-price-content">
                <div className="price-block">
                    {selectedDepartureDate && selectedDepartureDate.value && (
                        <>
                            <div className="price">
                                <span className="price-mention">{getText("booking.price.block.mention")}</span>
                                {selectedDepartureDate.value.price} <span>{getText("product.price.currency")}</span>
                            </div>
                            <div className="by">
                                <div>{getText("product.price.ttc")}/</div>
                                <div>{priceTypeLabel}</div>
                            </div>
                        </>
                    )}
                </div>
                <div className="brochure-price">
                    {selectedDepartureDate && selectedDepartureDate.value && selectedDepartureDate.value.regularPrice && (
                        <>
                            {getText("product.price.instead")}<span>{selectedDepartureDate.value.regularPrice}</span> {getText("product.price.currency")}
                        </>
                    )}
                </div>
                {/*disabled active-loader*/}
                <div className={"button-wrap"}>
                    <button type="submit" className={`elem-button elem-button--default ${disabled}`} onClick={(evt: SyntheticEvent) => handleSubmit(evt)}>
                        {getText("booking.book.label")} <Icon icon=">"/>
                    </button>
                    {isPrepackage && (
                        <>
                            <section className={`elem-loader-full  ${isSubmit ? "" : "d-none"}`}>
                                <div className="loader-content-prepackage">
                                    <p className="p1">{getText("booking.loader.info1")}</p>
                                    <p className="p2">{getText("booking.loader.info2")}</p>
                                    <p className="p2">{getText("booking.loader.info3")}</p>
                                    <p className="p3">{getText("booking.loader.info4")}</p>
                                    <div className="lds-ellipsis">
                                        <div/>
                                        <div/>
                                        <div/>
                                        <div/>
                                    </div>
                                    <span className="logo-pp">{getText("booking.loader.logo")}</span>
                                </div>
                            </section>
                        </>
                    )}
                    {!isPrepackage && (
                        <>
                            <section className={`elem-loader-full ${isSubmit ? "" : "d-none"}`}>
                                <div className="loader-content">
                                    <div className="lds-ellipsis">
                                        <div/>
                                        <div/>
                                        <div/>
                                        <div/>
                                    </div>
                                </div>
                            </section>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

/**
 * post
 * @param path
 * @param params
 * @param method
 */
function post(path: string, params = {}, method = "post") {

    // The rest of this code assumes you are not using a library.
    // It can be made less wordy if you use one.
    const form = document.createElement("form");
    form.method = method;
    form.action = path;

    for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key)) {
            const hiddenField = document.createElement("input");
            hiddenField.type = "hidden";
            hiddenField.name = key;
            hiddenField.value = params[key];

            form.appendChild(hiddenField);
        }
    }

    document.body.appendChild(form);
    form.submit();
}

/**
 * Remove loader from bfcache
 */
function removeLoader() {
    atPageBack(() => {
        document.querySelector(".elem-loader-full").classList.toggle("d-none", true);
    });
}

/**
 * Display the popin loader
 * @param isVisible
 */
function displayLoader(isVisible: boolean) {
    document.querySelector(".elem-loader-full").classList.toggle("d-none", !isVisible);
    document.querySelector("body").classList.toggle("no-scroll-active", isVisible);
}

export default BookingPrice;
